<div class="user-page">

  <!-- Header -->
  <div class="page-header">

    <div class="title-section">
      <div class="tabs-header">
        <ul>
          <li *ngFor="let data of appservice.User_Role_Menu"
            [className]="appservice.URL_Location==data.Link ? 'active' : ''"> 
            <a (click)="appservice.load_page(data.Link)">{{data.Menu}}</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="header-actions" style="display: flex; gap: 15px;">
      <button class="add-btn" (click)="addReset()">
        <span class="plus-icon">+</span> Add New
      </button>
      <button class="add-btn" (click)="this.display()">
        Refresh
      </button>
    </div>

  </div>

  <div class="table-card">

    <div class="col-md-12 nopad">
      <div class="spin_block" *ngIf="appservice.isload">
        <div class="d-flex justify-content-center">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
      <div class="m_2 res_table">
        <div class="search-bar_Ext mhide  show_bar " style="right: 120px;">

          <li class="bx bx-left-arrow-alt mshow  search_back"></li>

          <!-- <input  type="text"  (input)="dt.filterGlobal($event.target.value, 'contains')" 
                class="search-form-control text"
                placeholder="Search..."> -->

        </div>




        <p-table #dt class="table table-striped custom-table" [value]="Rows" [columns]="cols">
          <ng-template pTemplate="header">
            <tr>
              <th *ngFor="let col of cols" [pSortableColumn]="col.field" width="{{col.width}}" style="white-space: pre">
                {{col.header}}
                <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                  ariaLabelDesc="Activate to sort in descending order"
                  ariaLabelAsc="Activate to sort in ascending order">
                </p-sortIcon>
              </th>
              <th width=90>Action</th>
            </tr>


          </ng-template>
          <ng-template pTemplate="body" let-rowData let-car>
            <tr [pSelectableRow]="rowData">
              <td *ngFor="let col of cols">
                {{car[col.field]}}
              </td>
              <td class="text-right" style="white-space: pre">
                <a href="javascript:" style="font-size: 18px;padding: 5px" title="Edit" (click)="onEdit(rowData)"><i
                    class="bx bxs-pencil m-r-5"></i>

                </a>
                <a title="Delete" style="font-size: 18px;padding: 5px;color: firebrick"
                  (click)="onDelete(rowData.UM_ID)"><i class="bx bxs-trash m-r-5"></i>
                </a>
              </td>
            </tr>
          </ng-template>
        </p-table>

      </div>
    </div>

  </div>
</div>